const getDefaultState = () => {
  return {
    // !!!: an object that contains important data about current meeting
    meetingDetails: {
      meetingId: null,

      BuildingData: {},
      BuildingOwnersData: [],
      ContactsData: [],

      buildingOwnersWithReducedTantiemes: [],

      MajoritiesData: [],
      VotingCategoriesData: [],
    },
  };
};

export default {
  namespaced: true,
  state: getDefaultState(), // initial state
  mutations: {
    resetState(state) {
      // Merge rather than replace so we don't lose observers
      Object.assign(state, getDefaultState());
    },

    setFreezedMeetingDetails(state, payload) {
      state.meetingDetails = payload;
    },

    setMeetingDetailsMeetingId(state, payload) {
      state.meetingDetails = { ...state.meetingDetails, meetingId: payload };
    },

    setMeetingDetailsBuildingData(state, payload) {
      state.meetingDetails = { ...state.meetingDetails, BuildingData: payload };
    },

    setMeetingDetailsContactsData(state, payload) {
      state.meetingDetails = { ...state.meetingDetails, ContactsData: payload };
    },
    setMeetingDetailsBuildingOwnersData(state, payload) {
      state.meetingDetails = { ...state.meetingDetails, BuildingOwnersData: payload };
    },

    setMeetingDetailsBuildingOwnersWithReducedTantiemes(state, payload) {
      state.meetingDetails = {
        ...state.meetingDetails,
        buildingOwnersWithReducedTantiemes: payload,
      };
    },

    setMeetingDetailsMajoritiesData(state, payload) {
      state.meetingDetails = { ...state.meetingDetails, MajoritiesData: payload };
    },
    setMeetingDetailsVotingCategoriesData(state, payload) {
      state.meetingDetails = { ...state.meetingDetails, VotingCategoriesData: payload };
    },
    deleteMeetingDetailsContactsDataItem(state, contactId) {
      const changedContactsData = state.meetingDetails.ContactsData.filter(
        item => item.id != contactId
      );
      state.meetingDetails.ContactsData = changedContactsData;
    },
  },
  getters: {
    getMeetingDetailsContactsData(state) {
      return state.meetingDetails.ContactsData;
    },
  },
};
